// @flow
import I18n from '../i18n';
import config from '../../config/shippingConfig/kaizen';

const MAX_MIN_TO_SHOW_SECONDS = 1000;

function formatValue(
  value: ?any,
  withoutLabel?: boolean,
  withoutDecimals?: boolean,
  unitWhenZero?: string = 's'
): string {
  const numberValue = Number(value);
  if (!numberValue) {
    const result = '0';
    return withoutLabel ? result : result + `${I18n.t(`time.${unitWhenZero}`)}`;
  }

  const numberOfMinutes = Math.floor(numberValue / 60);

  if (withoutLabel && config.timeUsageFormat === 'minutes') {
    return numberOfMinutes.toString();
  }

  const restOfSeconds = numberValue % 60;

  let result = '';
  if (numberOfMinutes) {
    const numberOfMinutesRound = Math.floor(numberValue / 60);
    if (config.timeUsageFormat === 'hours') {
      const numberOfHoursRound = Math.floor(numberValue / 3600);
      const numberOfHoursString = numberOfHoursRound > 0 ? `${numberOfHoursRound}${I18n.t('time.h')}` : '';

      result += numberOfHoursString.toString();

      if (numberOfMinutesRound % 60 > 0) {
        if (numberOfHoursString) result += ' ';
        result += (numberOfMinutesRound % 60).toString();
        result += I18n.t('time.min');
      }
    } else {
      result += numberOfMinutesRound.toString();
      result += I18n.t('time.min');
    }
  }

  if (numberOfMinutes < MAX_MIN_TO_SHOW_SECONDS && restOfSeconds) {
    if (numberOfMinutes) {
      result += ' ';
    }
    result += Math.floor(restOfSeconds) + I18n.t(`time.s`);
  }

  return result;
}

export default formatValue;
